import {
  HomeColumns,
  HomeUsecaseInterface,
  UpdateStatusParams,
} from "./usecase.d";
import { HomeRepository } from "../../services/Home/home.repository";
import * as HomeReducer from "./reducer";
import { ActionType } from "./types";
import { GetListParams } from "../../services/Home/home.repository.d";
import { CreateHomeDto } from "../../services/Home/dto/create.dto";
import { UpdateHomeDto } from "../../services/Home/dto/update.dto";
import { LocalStorage } from "../../modules/LocalStorage";
import { RequestHomeDto } from "../../services/Home/dto/request.dto";

const HOME_COLUMN_KEY = "HomeColumns";

const defaultColumns: HomeColumns = {
  homeName: true,
  homeRange: true,
  homeStorey: false,
  homeBedNo: true,
  homeBathNo: true,
  homeGarageNo: true,
  homeFromPrice: false,
  homeToPrice: false,
  homeLotSize: false,
  homeLevelPath: false,
  homeFloorplanMapUrl: true,
};
export class HomeUsecase implements HomeUsecaseInterface {
  dispatch: HomeReducer.HomeDispatch;
  repository: HomeRepository;

  constructor(dispatch: HomeReducer.HomeDispatch) {
    this.repository = new HomeRepository();
    this.dispatch = dispatch;
  }

  async getList(params: GetListParams) {
    const response = await this.repository.getList(params);
    this.dispatch({
      type: ActionType.GetList,
      items: response,
    });
  }

  async create(params: CreateHomeDto) {
    const response = await this.repository.create(params);

    this.dispatch({
      type: ActionType.Create,
      addedItem: response.data,
    });
  }

  async request(params: RequestHomeDto) {
    const response = await this.repository.request(params);
    this.dispatch({
      type: ActionType.Create,
      addedItem: response.data,
    });
  }

  async delete(id: string) {
    await this.repository.delete(id);
    this.dispatch({
      type: ActionType.Delete,
      deleteId: id,
    });
  }

  async update(params: UpdateHomeDto) {
    const response = await this.repository.update(params);

    this.dispatch({
      type: ActionType.Update,
      updatedItem: response.data,
    });
  }

  async updateStatus(params: UpdateStatusParams) {
    this.dispatch({
      type: ActionType.UpdateStatus,
      updatedStatusItem: params,
    });

    try {
      await this.repository.update({
        id: params.id,
        isActive: params.isActive,
      });
    } catch (error) {
      this.dispatch({
        type: ActionType.UpdateStatus,
        updatedStatusItem: {
          id: params.id,
          isActive: !params.isActive,
        },
      });
      throw error;
    }
  }

  getDisplayColumns() {
    const columns =
      LocalStorage.getShowHideColumns<HomeColumns>(HOME_COLUMN_KEY);

    if (!columns) {
      return defaultColumns;
    }
    return columns;
  }

  setDisplayColumns(columns: HomeColumns) {
    LocalStorage.setShowHideColumns(HOME_COLUMN_KEY, columns);
  }
}
